import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '@/store/index';
import axios from '@/plugins/axios';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      requiresUnauth: true,
    },
  },
  {
    path: '/home',
    name: 'home',
    redirect: { name: 'listLoadOrders' },
    component: () => import('@/views/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/load-order',
    component: () => import(/* webpackChunkName: "load-order" */ '@/views/LoadOrder.vue'),
    children: [
      {
        name: 'editLoadOrder',
        path: 'edit/:bostamp',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/Form.vue'),
        meta: {
          requiresAuth: true,
        },
        props: true,
      },
      {
        name: 'createLoadOrder',
        path: 'create',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/Form.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'createDriverTemplate',
        path: 'create-driver-template',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/Form.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listLoadOrders',
        path: 'list',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/List.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listTransporter',
        path: 'list-transporter',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Transporter.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listPark',
        path: 'list-park',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Park.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listParkEntries',
        path: 'list-park-entries',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/ParkEntries.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listParkExits',
        path: 'list-park-exits',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/ParkExits.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listProvider',
        path: 'list-provider',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Provider.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listAgent',
        path: 'list-agent',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Agent.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listClient',
        path: 'list-client',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Client.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'ListTeams',
        path: 'list-teams',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Teams.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'listGlobal',
        path: 'list-global',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/Global.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'createDeliveryNote',
        path: '/create-delivery-note/:bostamp',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/forms/DeliveryNote.vue'),
        meta: {
          requiresAuth: true,
        },
        props: true,
      },
      {
        name: 'certifiedMaterial',
        path: 'certified-material',
        component: () => import(/* webpackChunkName: "load-order" */ '@/components/load-order/listings/CertifiedMaterialList.vue'),
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '*',
    component: () => import('@/views/NotFound.vue'),
    name: 'notFound',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url ?? '';
    const isLogoutRequest = /\/logout(?:$|\?)/.test(requestUrl);
    const isLoginRequest = /\/login(?:$|\?)/.test(requestUrl);

    if (status === 404) {
      router.push({ name: 'notFound' });
    }

    if (status === 401 && !isLogoutRequest && !isLoginRequest) {
      await store.dispatch('auth/logout');
      router.push({ name: 'login' });
    }

    return Promise.reject(error);
  },
);

router.beforeEach((to, _from, next) => {
  try {
    store.dispatch('auth/autoSignIn');
  } catch {
    // ignore — user will be redirected to login if needed
  }

  if (to.meta.requiresAuth && !store.getters['auth/isAuthenticated']) {
    next({ name: 'login' });
  } else if (to.meta.requiresUnauth && store.getters['auth/isAuthenticated']) {
    next({ name: 'home' });
  } else {
    next();
  }
});

export default router;
